module.exports = __webpack_public_path__ + "static/media/discover.e45f3fe2.svg";